<template>
  <div>
    <v-app-bar color="red-darken-3" class="pt-1">
      <!------------------------------------------TITLE------------------------------------------>
      <v-app-bar-title class="hidden-xs-only">
        {{ $t("leko_employees.approve_parts.label") }}
      </v-app-bar-title>
      <!----------------------------------------------------------------------------------------->
      <v-divider class="mx-5 hidden-xs-only" inset vertical />

      <!----------------------------------------------------------------------------------------->
      <!-- <v-spacer class="hidden-md-and-down"/> -->
      <!--------------------------------------SEARCH FIELD--------------------------------------->

      <!--
        <v-btn
          dark
          small
          @click="searchById = !searchById"
        >
          <v-icon left>
            {{ searchById ? 'check_box': 'check_box_outline_blank' }}
          </v-icon>
          {{ $t('leko_employees.approve_parts.id_only') }}
        </v-btn>
        -->
      <!----------------------------------------------------------------------------------------->
      <v-spacer class="hidden-md-and-down" />
      <v-btn
        v-if="$store.getters.role == 'SuperAdmin'"
        variant="flat"
        color="grey-darken-4"
        class="mx-1"
        @click="getCount"
      >
        {{ $t("parts.advanced_search.get_count") }}
        <v-icon end> mdi-magnify </v-icon>
      </v-btn>
      <!-----------------------------------AUTOMATIC APPROVAL------------------------------------>
      <v-btn theme="dark" disabled class="mx-1" @click="automaticApproval">
        {{ $t("leko_employees.approve_parts.automatic_approval.label") }}
      </v-btn>
      <!----------------------------------------------------------------------------------------->
    </v-app-bar>
    <div class="redColor pb-2 pt-3">
      <v-row class="pl-4 pr-4" align="center" justify="center" no-gutters>
        <!-------------------------------------EXPORT BUTTONS-------------------------------------->
        <v-btn
          color="grey-darken-4"
          theme="dark"
          class="ma-1"
          @click="exportToExcel"
        >
          {{ $t("leko_employees.approve_parts.export") }}
          <v-icon end>mdi-file-excel-outline</v-icon>
        </v-btn>
        <v-col ml-2 md="5" lg="4" class="hidden-sm-and-down mx-1">
          <v-text-field
            v-model="search"
            :class="{ 'ml-5': $vuetify.display.lgAndUp }"
            :label="$t('leko_employees.approve_parts.search')"
            name="approve-parts-search"
            autocomplete="off"
            text
            variant="solo"
            color="red-darken-1"
            append-inner-icon="mdi-magnify"
            single-line
            hide-details
            @keyup.enter="searchMethod"
            @click:append-inner="searchMethod"
          />
        </v-col>
        <!----------------------------------------------------------------------------------------->

        <!--SEARCH TYPE MD-AND-UP-->
        <v-col ml-2 md="2" lg="3" class="hidden-sm-and-down mx-1">
          <v-select
            v-model="searchType"
            :items="searchTypes"
            item-title="label"
            item-value="value"
            color="grey-darken-4"
            variant="solo"
            text
            hide-details
          />
        </v-col>

        <!--ADVANCED MD-AND-UP-->
        <v-btn
          class="mr-5 hidden-sm-and-down"
          theme="dark"
          small
          @click="advancedSearch = !advancedSearch"
        >
          <v-icon start>
            {{
              advancedSearch
                ? "mdi-checkbox-marked-outline"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
          {{ $t("leko_employees.approve_parts.advanced") }}
        </v-btn>
      </v-row>
      <!------------------------------------------------------------------------------------------->
      <v-row
        align-center
        justify-center
        :class="{ 'pt-1 pb-2': $vuetify.display.smAndDown }"
      >
        <v-spacer />

        <!--SEARCH TYPE SM-AND-DOWN-->
        <v-col xs="4" sm="2">
          <v-select
            v-model="searchType"
            :items="searchTypes"
            item-title="label"
            item-value="value"
            color="grey-darken-4"
            variant="solo"
            text
            hide-details
            class="hidden-md-and-up"
          />
        </v-col>

        <!--ADVANCED SM-AND-DOWN-->
        <v-btn
          class="hidden-md-and-up"
          dark
          small
          @click="advancedSearch = !advancedSearch"
        >
          <v-icon left>
            {{ advancedSearch ? "check_box" : "check_box_outline_blank" }}
          </v-icon>
          {{ $t("leko_employees.approve_parts.advanced") }}
        </v-btn>

        <v-spacer />
      </v-row>
      <!------------------------------------------------------------------------------------------->
      <form v-if="advancedSearch" autocomplete="off" @submit.prevent>
        <v-row row color="red-darken-3" class="pb-2 mt-2 pl-3 pr-3" wrap>
          <!--------------------------------------INSTITUTION-------------------------------------->
          <v-col xs="12" sm="6">
            <v-autocomplete
              v-model="institution"
              :items="institutions"
              :loading="loadingInstitution"
              :label="$t('parts.advanced_search.institution')"
              item-title="title"
              item-value="_id"
              name="approve-parts-institution"
              autocomplete="off"
              text
              variant="solo"
              color="red-darken-1"
            />
          </v-col>
          <!--------------------------------SENT FOR APPROVAL DATE--------------------------------->
          <v-col xs="6" sm="3">
            <!--STARTING DATE-->
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="startDate"
                  :value="formatDateToDisplay(startDate)"
                  :label="$t('parts.advanced_search.starting_date')"
                  :hint="$t('parts.advanced_search.select_starting_date')"
                  variant="solo"
                  flat
                  color="black"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="props"
                />
              </template>

              <v-date-picker
                v-model="startDate"
                color="red-darken-3"
                :max="endDate || null"
                @update:model-value="startDateMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col xs="6" sm="3">
            <!--ENDING DATE-->
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="endDate"
                  :value="formatDateToDisplay(endDate)"
                  :label="$t('parts.advanced_search.ending_date')"
                  :hint="$t('parts.advanced_search.select_ending_date')"
                  variant="solo"
                  flat
                  color="black"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="props"
                />
              </template>

              <v-date-picker
                v-model="endDate"
                color="red-darken-3"
                :min="startDate || null"
                @update:model-value="endDateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-col xs="12" md="12" lg="12">
          <v-row class="justify-center pb-2">
            <v-btn
              theme="dark"
              color="grey-darken-4"
              class="mx-1"
              @click="clearSearchFields"
            >
              {{ $t("parts.advanced_search.clear") }}
              <v-icon end> mdi-notification-clear-all </v-icon>
            </v-btn>
            <v-btn
              theme="dark"
              color="grey-darken-4"
              class="mx-1"
              @click="searchMethod"
            >
              {{ $t("parts.advanced_search.search") }}
              <v-icon end> mdi-magnify </v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </form>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

import getRequest from "../../api/getRequest";
import { useDisplay } from "vuetify";

export default {
  components: {},
  props: ["items"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    search: "",
    searchTypes: [
      { label: "Other", value: "other" },
      { label: "ID", value: "id" },
      { label: "PRA", value: "pra" },
    ],
    searchType: "other",
    advancedSearch: false,
    institution: null,
    institutions: [],
    loadingInstitution: false,
    startDateMenu: false,
    startDate: "",
    endDateMenu: false,
    endDate: "",
    institutionIds: [],
  }),
  computed: {
    display() {
      return useDisplay();
    },
  },
  watch: {
    search(value) {
      if (value.length === 0) {
        this.$emit("clear-search");
      }
    },
  },
  created() {
    this.getInstitutions();
    this.getLocale();
  },
  methods: {
    getCount() {
      this.$emit("adv-search-superadmin", {
        searchField: this.search,
        searchType: "other",
        institution: this.institutionIds,
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    searchMethod() {
      if (this.advancedSearch) {
        this.$emit("adv-search", {
          searchField: this.search,
          searchType: this.searchType,
          institution: this.institution,
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } else if (this.search.length > 0) {
        this.$emit("search", {
          searchField: this.search,
          searchType: this.searchType,
        });
      } else {
        //
      }
    },
    clearSearchFields() {
      this.institution = null;
      this.search = "";
      this.startDate = "";
      this.endDate = "";
      this.searchMethod();
    },
    async exportToExcel() {
      const data = await this.exportData();

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "approveparts");

      // Trigger download
      XLSX.writeFile(wb, "approveparts.xlsx");
    },
    exportData() {
      const items = [];
      this.$props.items.forEach((item) => {
        const itemObject = {
          ID: item._id,
          "Institution ID": item.institution_id.title,
          User: `${item.user_id.name} ${item.user_id.surname}`,
          Shipment: item.shipment_id.name,
        };
        items.push(itemObject);
      });
      return items;
    },
    automaticApproval() {
      this.$emit("automatic-approval");
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          response.institutions.forEach((item) => {
            this.institutionIds.push(item._id);
          });
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitution = false;
        });
    },
    getLocale() {
      this.searchTypes[0].label = this.$t("parts.inventory.other");
      this.searchTypes[1].label = this.$t("parts.inventory.id");
      this.searchTypes[2].label = this.$t("parts.inventory.pra");
    },
    formatDateToDisplay(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0"); // 0-indexed
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
